var render = function render(){var _vm=this,_c=_vm._self._c;return _c('client-only',[_c('button',{staticClass:"vue-btn",class:_vm.getBackgroundClass},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('div',{class:_vm.getSpinnerClass})]),_vm._v(" "),(_vm.showSlot)?_vm._t("default"):_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }